import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Ethnicity({ item, index }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">Non Hispanic</div>
    } else {
      return <>
        <div className="col-8">Ethnicity</div>
        <div className="col-4">Non Hispanic</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}